// extracted by mini-css-extract-plugin
module.exports = {"animatedButton":"user_animatedButton__P8oDz"};